import { GridRenderCellParams } from '@mui/x-data-grid'

const dash = (params: GridRenderCellParams) =>
  params?.value != null && String(params.value).trim() !== ''
    ? params.value
    : '-'

function radiusCell(params: GridRenderCellParams) {
  if (params.value == null) return '-'
  return parseFloat((params.value as number).toFixed(1))
}

export function getRooExportSettingsColumns(useKilometers: boolean) {
  return [
    { field: 'id', headerName: 'ID', minWidth: 80, flex: 0, sortable: false },
    {
      field: 'carrierId',
      headerName: 'Carrier ID',
      minWidth: 100,
      flex: 0,
      sortable: false,
    },
    {
      field: 'carrierName',
      headerName: 'Carrier Name',
      minWidth: 160,
      flex: 2,
      sortable: true,
      renderCell: dash,
    },
    {
      field: 'dotNumber',
      headerName: 'DOT',
      minWidth: 100,
      flex: 0.8,
      sortable: true,
      renderCell: dash,
    },
    {
      field: 'cuid',
      headerName: 'CUID',
      minWidth: 120,
      flex: 0.8,
      sortable: true,
      renderCell: dash,
    },
    {
      field: 'policyId',
      headerName: 'Policy ID',
      minWidth: 120,
      flex: 0.8,
      sortable: true,
      renderCell: dash,
    },
    {
      field: 'radius1',
      headerName: 'Radius 1',
      minWidth: 100,
      flex: 0.5,
      sortable: true,
      renderCell: radiusCell,
    },
    {
      field: 'radius2',
      headerName: 'Radius 2',
      minWidth: 100,
      flex: 0.5,
      sortable: true,
      renderCell: radiusCell,
    },
    {
      field: 'radius3',
      headerName: 'Radius 3',
      minWidth: 100,
      flex: 0.5,
      sortable: true,
      renderCell: radiusCell,
    },
    {
      field: 'radius4',
      headerName: 'Radius 4',
      minWidth: 100,
      flex: 0.5,
      sortable: true,
      renderCell: radiusCell,
    },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      minWidth: 180,
      flex: 1,
      sortable: true,
      renderCell: (params: GridRenderCellParams) =>
        params.value ? new Date(params.value).toLocaleString() : '-',
    },
  ]
}

export const actionList = [
  { name: 'Edit', icon: 'icon_edit', iconSize: 40 },
  { name: 'Remove', icon: 'icon_delete', iconSize: 40 },
]
